import React from 'react';

import { Chip } from '@mui/material';

interface Props {
  value: boolean;
}

export default function BooleanChip({ value }: Props) {
  return (
    <Chip
      color={value ? 'primary' : 'default'}
      label={value ? 'Yes' : 'No'}
      size="small"
      variant={value ? 'filled' : 'outlined'}
    />
  );
}
